<app-topbar></app-topbar>
<app-sidebar></app-sidebar>
<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">Fund History</h3>
          <p class="page-head__sub">Fund Details</p>
        </div>
      </div>
    </div>


    <div class="content-body">
      <!-- Revenue, Hit Rate & Deals -->
      <div class="row">
        <div class="col-12">
          <div class="row  all-details" >
            <div class="col-md-6">

              <div class="card-header border-right row " style="height: 100% !important;">

                <div class="col-md-5 heading">Date</div>
                <div class="col-md-7 detail">{{$safeNavigationMigration(data?.created_at) | date}}</div>


                <div class="col-md-5 heading" >IMTO Name</div>
                <div class="col-md-7 details">@if ($safeNavigationMigration(data?.agent) !== null) {
                  <a [routerLink]="['/agent',$safeNavigationMigration(data?.agent?.slug)]" >{{data?.agent.name}}</a>
                }</div>

                <div class="col-md-5 heading">Exchange Rate</div>
                <div class="col-md-7 details">{{$safeNavigationMigration(data?.exchange_rate) | number }}</div>


                <div class="col-md-5 heading">Amount in Naira</div>
                <div class="col-md-7 details" >NGN {{$safeNavigationMigration(data?.amount_in_naira) | number}}</div>

                <div class="col-md-5 heading">Amount in {{data?.currency?.code }}</div>
                <div class="col-md-7 details">{{data?.currency?.code }} {{$safeNavigationMigration(data?.amount_in_usd) | number}}</div>

              </div>

            </div>
            <div class="col-md-6">
              <div class="card-header   row" style="height: 100% !important;">

                <div class="col-md-5 heading">New balance</div>
                <div class="col-md-7 detail">NGN {{$safeNavigationMigration(data?.current_balance) | number }}</div>

                @if (data?.status === 'reverted') {
                  <div class="col-md-5 heading">Status</div>
                }
                <div class="col-md-7 detail">
                  @if (data?.status === 'reverted') {
                    <span class="status-badge status-reverted" >{{data?.status }} </span>
                  }
                  @if (data?.status  === 'reverted') {
                    <span> {{$safeNavigationMigration(data?.updated_at) | date}}</span>
                  }
                  @if (data?.status  === 'active' && details?.permission === 'super_admin') {
                    <button class="btn btn-outline-success round" (click)="revertFund($safeNavigationMigration(data?.id))"> REVERT FUND</button>
                  }</div>
                </div>

              </div>


            </div>
          </div>
        </div>


      </div>


    </div>
  </div>
  <app-bottombar></app-bottombar>
